import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyAohhwU3lVRTY1LeTNj582XzlYendRCxzw",
    authDomain: "reservas-1ee4a.firebaseapp.com",
    projectId: "reservas-1ee4a",
    storageBucket: "reservas-1ee4a.firebasestorage.app",
    messagingSenderId: "702560128352",
    appId: "1:702560128352:web:8d078ed8d0eee6d67aa205",
    measurementId: "G-SSRJFNRHHL"
  };

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const config = firebaseConfig;